export default "__VITE_ASSET__949c7f26__"